import _ from 'lodash'
import { Component } from 'react'
import PropTypes from 'prop-types'

class SettingManager extends Component {
    constructor(props) {
        super(props)

        // Expose the commands to dev console
        window.setClientVersion = this.setClientVersion
        window.setVersion = this.setLauncherVersion
        window.setSettings = this.setSettings
        window.initializeVersion = this.initializeUIVersion
        window.setPlayable = this.setPlayable
        window.setToken = this.setToken
        window.setTokens = this.setTokens
        window.showError = this.showError
    }

    shouldComponentUpdate() {
        return false
    }

    // Update the EVE client version
    setClientVersion = (server, clientVersion) => {
        try {
            // If active server is the same as provided
            // by the backend we can update the client version
            if (this.props.activeServer === server) {
                this.props.setClientVersion(clientVersion)
            }
        } catch (error) {
            console.info(`Encountered error while running setClientVersion: ${error.message}`)
        }
    }

    // Update the launcher version
    setLauncherVersion = (launcherVersion) => {
        try {
            this.props.setLauncherVersion(launcherVersion)
        } catch (error) {
            console.info(`Encountered error while running setLauncherVersion: ${error.message}`)
        }
    }

    setToken = (serverName) => {
        try {
            // Get the name of the current server,
            // or substitude undefined with "server"
            const server = serverName != null ? serverName : this.props.activeServer || 'server'

            // Get the list of users for the given server
            const users = this.props.users[server]

            // If we have users in the list, get the first user and answer
            // with their refresh token
            if (users !== undefined && Object.keys(users).length > 0) {
                const key = Object.keys(users)[0]

                // Get first user in object
                const user = users[key]

                if (user != null && user.tokens != null && user.tokens.refreshToken !== undefined) {
                    // Fire off the command to set the token
                    this.props.setToken(server, user.tokens.refreshToken)
                    return
                } else if (user == null) {
                    console.info(`No token was available, as user object for ${key} is null`)
                    return
                } else if (user.tokens == null) {
                    console.info(`No token was available, as user token object for ${key} is null`)
                    return
                }
            }
            console.info(`No token was available for ${server}`)
        } catch (error) {
            console.info(
                `Encountered error while running setToken (${serverName ||
                    'no server selected'}): ${error.message}`,
            )
        }
    }

    setTokens = () => {
        try {
            // Validation that data is available to set tokens
            // Required are servers & users
            if (_.size(this.props.servers) === 0) {
                // We have no servers, fail the condition. Create an entry in the logs and return.
                console.info('No servers were available for setTokens')
                return
            } else if (_.size(this.props.users) === 0) {
                // We have no users, failure condition. Create an entry in the logs and return.
                console.info('No users were available for setTokens')
                return
            }

            // We have both servers and users
            // lets find a token for every server and report it
            _.forEach(this.props.servers, (server) => {
                if (_.size(this.props.users[server.shortName]) > 0) {
                    // Server has one or more accounts pinned
                    this.setToken(server.shortName)
                }
            })
        } catch (error) {
            console.info(`Encountered an error while running setTokens: ${error.message}`)
        }
    }

    // Update the settings for the launcher
    setSettings = (settings) => {
        try {
            // If the EVE servers have not been populated
            // we fill them up with static data
            if (Object.keys(this.props.servers).length === 0) {
                console.info(
                    'No servers received from the launcher application but settings have already been set. Manually populating server list.',
                )
                window.addServers([
                    { name: 'tq', displayName: 'Tranquility' },
                    { name: 'sisi', displayName: 'Singularity' },
                    { name: 'duality', displayName: 'Duality' },
                    { name: 'thunderdome', displayName: 'Thunderdome' },
                ])
            }

            // If the launcher UI version hasn't bee updated
            // we need to update that
            this.initializeUIVersion()

            // Store away the incoming settings
            this.props.saveSettings(settings)
        } catch (error) {
            console.info(`Encountered error while running setSettings: ${error.message}`)
        }
    }

    setPlayable = () => {
        // Do nothing (unused, but launcher references this)
    }

    initializeUIVersion = () => {
        try {
            const regex = new RegExp(this.props.regex.version, 'i')
            const pathValue = window.location.pathname.match(regex)

            if (pathValue != null) {
                this.props.setUiVersion(pathValue[1])
            }
        } catch (error) {
            console.info(`Encountered error while running initializeUIVersion: ${error.message}`)
        }
    }

    // Show error that should create a notification in the UI when called
    showError = (title, message, timeout, persistent = false) => {
        // TODO: languages
        const localized = _.mapValues(this.props.languages, () => ({
            title: `${title}`,
            content: `${message}`,
        }))

        this.props.showError({
            localized,
            timeout,
            alwaysOnTop: true,
            persistent,
        })
    }

    render() {
        return null
    }
}

SettingManager.propTypes = {
    languages: PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.string,
    }),
    activeServer: PropTypes.string,
    servers: PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.shape({
            shortName: PropTypes.string,
        }),
    }),
    users: PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.shape({
            tokens: PropTypes.shape({
                refreshToken: PropTypes.string,
            }),
        }),
    }),
    regex: PropTypes.shape({
        version: PropTypes.string,
    }),
    setToken: PropTypes.func,
    setClientVersion: PropTypes.func,
    setLauncherVersion: PropTypes.func,
    setUiVersion: PropTypes.func,
    saveSettings: PropTypes.func,
    showError: PropTypes.func,
}

export default SettingManager



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/SettingManager/component.js